/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_No_AccountInputs */

const en_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't have an account? `)
};

const de_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Konto? `)
};

const fr_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'as pas de compte ?`)
};

const es_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No tiene una cuenta? `)
};

const it_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai un account? `)
};

const nl_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen account? `)
};

const pl_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie masz konta? `)
};

const fi_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eikö sinulla ole tiliä? `)
};

const da_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du ikke en konto? `)
};

const sv_auth_no_account = /** @type {(inputs: Auth_No_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Har du inget konto? `)
};

/**
* | output |
* | --- |
* | "Don't have an account?" |
*
* @param {Auth_No_AccountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_no_account = /** @type {((inputs?: Auth_No_AccountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_No_AccountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_no_account(inputs)
	if (locale === "fr") return fr_auth_no_account(inputs)
	if (locale === "es") return es_auth_no_account(inputs)
	if (locale === "it") return it_auth_no_account(inputs)
	if (locale === "nl") return nl_auth_no_account(inputs)
	if (locale === "pl") return pl_auth_no_account(inputs)
	if (locale === "fi") return fi_auth_no_account(inputs)
	if (locale === "da") return da_auth_no_account(inputs)
	if (locale === "sv") return sv_auth_no_account(inputs)
	return en_auth_no_account(inputs)
});